module.exports = __webpack_public_path__ + "img/video-1.8e5216ab.jpeg";